/** Which colour a status is, in one place, so two screens never disagree. */

type Colour = "default" | "primary" | "secondary" | "success" | "error" | "info" | "warning";

const STATUS: Record<string, Colour> = {
  // instances
  active: "success", running: "info", provisioning: "info", upgrading: "info",
  archiving: "info", reinstating: "info", destroying: "warning",
  suspended: "warning", requested: "default", archived: "default",
  destroyed: "default", failed: "error",
  // jobs
  queued: "default", succeeded: "success", cancelled: "warning", pending: "default",
  // demo requests
  submitted: "info", approved: "success", rejected: "error", live: "success",
  expiring: "warning", expired: "warning", purged: "default", reinstated: "success",
  promoted: "primary",
  // production sites: an on-prem one reports in rather than being run by us
  reporting: "success", activated: "default",
  // health, fleet, licences
  ok: "success", healthy: "success", degraded: "warning", unreachable: "error",
  amber: "warning", red: "error", green: "success", unknown: "default",
  stale: "warning", offline: "error", online: "success", revoked: "error",
  // partners, opportunities
  pending_approval: "warning", suspended_org: "warning",
  // A pursuit walks through these, so they must not all look the same.
  intake: "default", briefed: "info", recommended: "primary",
  generating: "info", generated: "success", demo_requested: "secondary",
  // templates and modules
  published: "success", yanked: "error", draft: "default", retired: "default",
  // support: tickets, compliance alerts, email and webhook deliveries
  in_progress: "info", shipped: "info", received: "info", resolved: "success",
  open: "warning", acknowledged: "info", erased: "default", declined: "error",
  sending: "info", sent: "success", skipped: "default", deleted: "default",
  // OTA rollouts and demo packs
  canary: "info", released: "primary", halted: "error", completed: "success",
  deprecated: "default",
};

export function statusColour(status: string | null | undefined): Colour {
  if (!status) return "default";
  return STATUS[status.toLowerCase()] ?? "default";
}

/** True when a status means "something is happening, poll me". */
export function isBusy(status: string | null | undefined): boolean {
  return ["queued", "running", "provisioning", "upgrading", "archiving",
          "reinstating", "destroying", "generating"].includes(status ?? "");
}
